"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Container = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactIntl = require("react-intl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uxcore = require("@ux/uxcore2");

var _helpBot = _interopRequireDefault(require("@ua/help-bot"));

var _helpChat = _interopRequireDefault(require("@ua/help-chat"));

var _helpBrowse = _interopRequireDefault(require("@ua/help-browse"));

var _constants = require("../constants");

var _props = require("../props");

var _styles = _interopRequireDefault(require("../styles"));

var _actions = require("../store/actions");

var _notification = _interopRequireDefault(require("../sounds/notification"));

var _utilities = require("../utilities");

var _Style = _interopRequireDefault(require("./Style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// TODO: Delete this after removing <HelpBot />
var getVisitorId = function getVisitorId() {
  if (typeof window !== 'undefined' && window.document && window.document.cookie) {
    var visitorIdCookie = window.document.cookie.replace(/(?:(?:^|.*;\s*)visitor\s*\=\s*([^;]*).*$)|^.*$/, '$1');
    return visitorIdCookie.split('=')[1];
  }

  return '';
};

var Container =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Container, _PureComponent);

  function Container(props) {
    var _this;

    _classCallCheck(this, Container);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Container).call(this, props));
    _this.onNotification = _this.onNotification.bind(_assertThisInitialized(_this));
    _this.pipeExpVariantToState = _this.pipeExpVariantToState.bind(_assertThisInitialized(_this));
    _this.state = {
      showMessaging: _this.props.showMessaging || false
    };
    var activeTab = props.activeTab,
        tabInitial = props.tabInitial,
        tabs = props.tabs;
    if (!activeTab) props.appActiveTabSet(tabInitial || tabs[0]);
    return _this;
  }

  _createClass(Container, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.pipeExpVariantToState({
        expId: 'help_container_show_messaging',
        stateFieldName: 'showMessaging',
        attributes: {},
        stateValueTransformer: function stateValueTransformer(splitValue) {
          // eslint-disable-next-line no-console
          console.log("Split Value for messaging: ".concat(splitValue));
          var stateValue = _this2.props.showMessaging === true ? true : splitValue === 'on'; // eslint-disable-next-line no-console

          console.log("State Value for showMessaging ".concat(stateValue));
          return stateValue;
        }
      });
    }
  }, {
    key: "pipeExpVariantToState",
    value: function pipeExpVariantToState(_ref, done) {
      var _this3 = this;

      var expId = _ref.expId,
          _ref$attributes = _ref.attributes,
          attributes = _ref$attributes === void 0 ? {} : _ref$attributes,
          stateFieldName = _ref.stateFieldName,
          _ref$stateValueTransf = _ref.stateValueTransformer,
          stateValueTransformer = _ref$stateValueTransf === void 0 ? function (variantId) {
        return variantId;
      } : _ref$stateValueTransf;
      if (typeof window === 'undefined') return;
      var expDataLayer = window._expDataLayer = window._expDataLayer || [];

      var pipeVariantToState = function pipeVariantToState(variantId) {
        _this3.setState(_defineProperty({}, stateFieldName, stateValueTransformer(variantId)), done);
      };

      expDataLayer.push({
        schema: 'get_variant_for_experiment',
        version: 'v1',
        data: {
          experiment_id: expId,
          callback: pipeVariantToState,
          attributes: attributes
        }
      });
    }
  }, {
    key: "handleClickTab",
    value: function handleClickTab(tabName) {
      this.props.trafficTabClick({
        tab: tabName
      }); // this must take place first for awareness of the old tab

      this.props.appActiveTabSet(tabName);
    }
  }, {
    key: "onNotification",
    value: function onNotification(messageText) {
      var minimized = this.props.minimized;
      var messageTextScrubbed = messageText.replace(/(<([^>]+)>)/ig, '');
      if (minimized) this.props.appNotificationsSet(1);
      if (!(0, _utilities.notificationPermissionGranted)()) (0, _utilities.audioPlay)(_notification.default);
      (0, _utilities.notificationSend)({
        body: messageTextScrubbed,
        title: 'New Live Chat Message'
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          activeTab = _this$props.activeTab,
          env = _this$props.env,
          market = _this$props.market,
          product = _this$props.product,
          shopperId = _this$props.shopperId,
          welcomeIntent = _this$props.welcomeIntent;
      var showMessaging = this.state.showMessaging;
      return _react.default.createElement("div", {
        className: "help--container-content"
      }, _react.default.createElement("div", {
        id: "help-browse",
        className: (0, _classnames.default)('help--container-content-inner', activeTab !== _constants.TAB_BROWSE ? 'help--is-hidden' : '')
      }, _react.default.createElement(_helpBrowse.default, {
        env: env,
        market: market,
        topicId: product && product.split('-').pop() || null
      })), _react.default.createElement("div", {
        id: "help-bot",
        className: (0, _classnames.default)('help--container-content-inner', activeTab !== _constants.TAB_CONTACT ? 'help--is-hidden' : '')
      }, showMessaging ? _react.default.createElement(_helpChat.default, {
        env: env,
        market: market,
        product: product,
        onNotification: this.onNotification
      }) : _react.default.createElement(_helpBot.default, {
        env: env,
        market: market,
        onChatMessage: this.onNotification,
        productId: product,
        sessionId: "help-bot-".concat(getVisitorId()),
        shopperId: shopperId,
        welcomeIntent: welcomeIntent
      })));
    }
  }, {
    key: "renderTab",
    value: function renderTab(tabName, index) {
      var _this4 = this;

      var activeTab = this.props.activeTab;

      if (tabName === _constants.TAB_BROWSE) {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)('help--container-tab', activeTab === _constants.TAB_BROWSE ? 'help--container-tab-active' : ''),
          onClick: function onClick() {
            return _this4.handleClickTab(_constants.TAB_BROWSE);
          },
          onKeyDown: null,
          role: "button",
          tabIndex: 0,
          key: index
        }, _react.default.createElement("span", null, "Browse Help"));
      } else if (tabName === _constants.TAB_CONTACT) {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)('help--container-tab', activeTab === _constants.TAB_CONTACT ? 'help--container-tab-active' : ''),
          onClick: function onClick() {
            return _this4.handleClickTab(_constants.TAB_CONTACT);
          },
          onKeyDown: null,
          role: "button",
          tabIndex: 0,
          key: index
        }, _react.default.createElement("span", null, "Contact Us"));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props2 = this.props,
          breakpoint = _this$props2.breakpoint,
          draggable = _this$props2.draggable,
          market = _this$props2.market,
          position = _this$props2.position,
          resetPosition = _this$props2.resetPosition,
          standalone = _this$props2.standalone,
          tabs = _this$props2.tabs;
      return _react.default.createElement("div", {
        className: "help--container-container"
      }, _react.default.createElement("div", {
        className: "help--container-upper"
      }, !standalone && _react.default.createElement("div", {
        className: (0, _classnames.default)('help--container-controls-top', 'help--drag-handle')
      }, _react.default.createElement("div", {
        className: "help--container-controls-top-middle"
      }, market !== _constants.MARKET_EN_US && _react.default.createElement(_reactIntl.FormattedMessage, {
        id: "Help"
      })), _react.default.createElement("div", {
        className: "help--container-controls-top-left"
      }, draggable && _react.default.createElement("div", {
        className: (0, _classnames.default)('help--container-controls-top-icon', 'help--drag-handle'),
        title: "Click here to drag"
      }, _react.default.createElement(_uxcore.Icon, {
        name: "grab-vert",
        size: 20,
        color: _styles.default.colors.grayLight
      })), draggable && _react.default.createElement("div", {
        className: "help--container-controls-top-icon",
        onClick: function onClick() {
          resetPosition && resetPosition();

          _this5.props.trafficDock();
        },
        onKeyDown: null,
        role: "button",
        tabIndex: 0,
        style: {
          transform: position === _constants.POSITION_LEFT ? 'scale(-1, -1)' : 'scale(1, -1)'
        },
        title: "Reset position and size"
      }, _react.default.createElement(_uxcore.Icon, {
        name: "window",
        size: 20,
        color: _styles.default.colors.gray
      }))), _react.default.createElement("div", {
        className: "help--container-controls-top-right"
      }, _react.default.createElement("div", {
        className: "help--container-controls-top-icon",
        onClick: function onClick() {
          return _this5.props.handleChangeMinimized(true);
        },
        onKeyDown: null,
        role: "button",
        tabIndex: 0,
        title: "Minimize"
      }, _react.default.createElement(_uxcore.Icon, {
        name: "minus",
        size: 20,
        color: _styles.default.colors.gray
      })))), _react.default.createElement("div", {
        className: (0, _classnames.default)('help--container-top', 'help--drag-handle')
      }), tabs.length > 1 && _react.default.createElement("div", {
        className: "help--container-tabs"
      }, tabs.map(function (tab, index) {
        return _this5.renderTab(tab, index);
      }))), tabs.length === 1 && this.renderContent(), tabs.length > 1 && this.renderContent(), _react.default.createElement(_Style.default, {
        css: "\n          .help--container-container {\n            background-color: ".concat(_styles.default.colors.white, ";\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n            position: absolute;\n            width: 100%;\n          }\n\n          .help--container-upper {\n            border-bottom: 1px solid lightgray;\n            min-height: 50px;\n          }\n\n          .help--container-controls-top {\n            display: flex;\n            justify-content: space-between;\n            left: 0;\n            position: absolute;\n            top: 0;\n            width: 100%;\n          }\n\n          .help--container-controls-top-middle {\n            align-items: center;\n            display: flex;\n            font-size: 20px;\n            font-weight: bold;\n            height: 50px;\n            justify-content: center;\n            position: absolute;\n            width: 100%;\n          }\n\n          .help--container-controls-top-left,\n          .help--container-controls-top-right {\n            display: flex;\n          }\n\n          .help--container-controls-top-left {\n            padding-left: 4px;\n          }\n          @media (max-width: ").concat(breakpoint, "px) {\n            .help--container-controls-top-left {\n              visibility: hidden;\n            }\n          }\n\n          .help--container-controls-top-right {\n            padding-right: 4px;\n          }\n\n          .help--container-controls-top-icon {\n            align-items: center;\n            cursor: pointer;\n            display: flex;\n            padding: 4px;\n            padding-bottom: 8px;\n            padding-top: 8px;\n          }\n          .help--container-controls-top-icon:focus {\n            outline: none;\n          }\n\n          .help--container-top {\n            height: 38px;\n          }\n\n          .help--container-top-image {\n            width: 125px;\n          }\n\n          .help--container-tabs {\n            display: flex;\n            font-size: 17px;\n          }\n\n          .help--container-tab {\n            align-items: center;\n            cursor: pointer;\n            display: flex;\n            height: 44px;\n            justify-content: center;\n            outline: none;\n            padding-bottom: 3px;\n            position: relative;\n            text-align: center;\n            width: 100%;\n          }\n          .help--container-tab-active:after {\n            background-color: ").concat(_styles.default.colors.blue, ";\n            background-image: linear-gradient(45deg, ").concat(_styles.default.colors.blue, ", ").concat(_styles.default.colors.purple, ");\n            bottom: 0;\n            content: '';\n            height: 4px;\n            left: 0;\n            position: absolute;\n            width: 100%;\n          }\n\n          .help--container-content {\n            flex: 1;\n            overflow-y: hidden;\n            position: relative;\n          }\n\n          .help--container-content-inner {\n            bottom: 0;\n            left: 0;\n            position: absolute;\n            top: 0;\n            width: 100%;\n          }\n        ")
      }));
    }
  }]);

  return Container;
}(_react.PureComponent);

exports.Container = Container;
Container.propTypes = {
  activeTab: _propTypes.default.string,
  appActiveTabSet: _propTypes.default.func.isRequired,
  appNotificationsSet: _propTypes.default.func.isRequired,
  breakpoint: _props.propTypes.breakpoint,
  draggable: _props.propTypes.draggable,
  env: _props.propTypes.env,
  handleChangeMinimized: _propTypes.default.func.isRequired,
  market: _props.propTypes.market,
  minimized: _propTypes.default.bool.isRequired,
  product: _props.propTypes.product,
  position: _props.propTypes.position,
  resetPosition: _propTypes.default.func,
  shopperId: _props.propTypes.shopperId,
  showMessaging: _props.propTypes.showMessaging,
  standalone: _props.propTypes.standalone,
  tabInitial: _props.propTypes.tabInitial,
  tabs: _props.propTypes.tabs,
  trafficDock: _propTypes.default.func.isRequired,
  trafficTabClick: _propTypes.default.func.isRequired,
  welcomeIntent: _props.propTypes.welcomeIntent
};
Container.defaultProps = {
  breakpoint: _props.defaultProps.breakpoint,
  draggable: _props.defaultProps.draggable,
  env: _props.defaultProps.env,
  market: _props.defaultProps.market,
  position: _props.defaultProps.position,
  shopperId: _props.defaultProps.shopperId,
  showMessaging: _props.defaultProps.showMessaging,
  standalone: _props.defaultProps.standalone,
  tabs: _props.defaultProps.tabs,
  welcomeIntent: _props.defaultProps.welcomeIntent
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeTab: state.app.activeTab,
    minimized: state.app.minimized
  };
};

var mapDispatchToProps = {
  appActiveTabSet: _actions.appActiveTabSet,
  appNotificationsSet: _actions.appNotificationsSet,
  trafficDock: _actions.trafficDock,
  trafficTabClick: _actions.trafficTabClick
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Container);

exports.default = _default;